module.exports = __webpack_public_path__ + "assets/img/local.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon/local.png
// module id = 1942
// module chunks = 0